<div class="bottom-sheet-content" #gestureArea>
  <div class="sheet-header">
    <div class="handle-bar"></div>
    <div class="back-button" (click)="cancel()" (keydown)="cancel()" tabindex="0">
      <img src="assets/ic-close.svg" alt="cancel icon" />
    </div>
  </div>

  <div class="title section-title-container">
    <h2>Switch Charity</h2>
    <ion-note>Select which charity to manage</ion-note>
  </div>

  <div class="charity-list">
    <ion-list lines="none">
      @for (charity of permittedCharities; track charity) {
        <ion-item
          button
          (click)="selectCharity(charity)"
          [disabled]="isSwitching"
          [class.selected]="charity.id === currentCharityId"
          >
          <div class="charity-item">
            <div class="image-wrapper square small">
              @if (!imageLoadedMap[charity.id ?? ''] && charity.avatarUrl) {
                <ion-skeleton-text animated></ion-skeleton-text>
              }
              <ion-img
                [alt]="charity.name + ' logo'"
                [src]="charity.avatarUrl || 'assets/ic-charity.svg'"
                (ionImgDidLoad)="onImageLoad(charity.id ?? '')"
                [class.hidden]="!imageLoadedMap[charity.id ?? ''] && charity.avatarUrl"
                [class.fade-in]="charity.avatarUrl"
              ></ion-img>
            </div>
            <div class="charity-info">
              <ion-label>
                <h3>{{ charity.name }}</h3>
                @if (charity.city && charity.state) {
                  <p>{{ charity.city }}, {{ charity.state }}</p>
                }
              </ion-label>
            </div>
            @if (charity.id === currentCharityId) {
              <ion-icon
                name="checkmark-circle"
                color="primary"
                class="selected-icon"
              ></ion-icon>
            }
          </div>
        </ion-item>
      }
    </ion-list>
  </div>

  @if (isSwitching) {
    <div class="action-footer">
      <ion-spinner name="crescent"></ion-spinner>
      <ion-text color="medium">Switching charity...</ion-text>
    </div>
  }
</div>